import React, {useState} from "react";
import ReactBSAlert from "react-bootstrap-sweetalert";

const useAlert = () => {

    const [alert, setAlert] = useState(null);

    const hideAlert = () => {
        setAlert(null);
    };

    const successAlert = (message, successHandler) => {
        setAlert(
            <ReactBSAlert
                style={{ color: 'black' }}
                success
                title="Success!"
                onConfirm={() => {
                    // 1. If the user provided a function, run it
                    if (successHandler) successHandler();
                    // 2. ALWAYS close the alert regardless
                    hideAlert();
                }}
                confirmBtnBsStyle="success"
                btnSize=""
            >
                {message}
            </ReactBSAlert>
        );
    };

    const errorAlert = (message, errorHandler) => {
        setAlert(
            <ReactBSAlert
                error
                style={{ color: 'black' }}
                title="Error!"
                onConfirm={errorHandler || hideAlert}
                confirmBtnBsStyle="error"
                btnSize=""
            >
                {message}
            </ReactBSAlert>
        );
    };

    const confirmAlert = (message, confirmHandler, cancelHandler) => {
        setAlert(
          <ReactBSAlert
            type="warning"
            style={{ color: 'black' }}
            title="Confirm!"
            onConfirm={() => {
                // 1. If the user provided a function, run it
                if (confirmHandler) confirmHandler();
                // 2. ALWAYS close the alert regardless
                hideAlert();
            }}
            onCancel={() => {
                // 1. If the user provided a function, run it
                if (cancelHandler) cancelHandler();
                // 2. ALWAYS close the alert regardless
                hideAlert();
            }}
            confirmBtnBsStyle="success"
            showCancel
            confirmBtnText="PROCEED"
            cancelBtnText="CANCEL"
            cancelBtnBsStyle="error"
            btnSize=""
          >
              {message}
          </ReactBSAlert>,
        );
    };

    const infoAlert = (message) => {
        setAlert(
            <ReactBSAlert
                type="info"
                style={{ color: 'black',  }}
                title="Info!"
                onConfirm={hideAlert}
                onCancel={hideAlert}
                confirmBtnBsStyle="success"
                confirmBtnText="OK"
                btnSize=""
            >
                {message}
            </ReactBSAlert>
        );
    };

    return {
        alert,
        successAlert,
        errorAlert,
        confirmAlert,
        infoAlert
    };
}

export default useAlert;